import React from 'react';
import { translate, Interpolate } from 'react-i18next';
import { Link } from 'react-router';
import classnames from 'classnames';

import Button from 'components/atoms/Button';

import styles from './index.css';

const CookieBar = ({
	// translation
	t,

	// props
	className,

	// redux data
	active,

	// dispatch action
	onConfirm,
}) => (
	<div className={classnames(styles.cookieBar, className, { [styles.active]: active })}>
		<div className={styles.container}>
			<div className={styles.confirmText}>
				<Interpolate
					i18nKey="attention"
					useDangerouslySetInnerHTML="true"
					privacyLink={<Link to="/privacy">{t('privacy')}</Link>}
				/>
			</div>
			<Button
				className={styles.button}
				contentClassName={styles.buttonContent}
				animation={false}
				reverse
				onClick={onConfirm}
			>
				{t('accept')}
			</Button>
		</div>
	</div>
);

export default translate('cookieBar')(CookieBar);



// WEBPACK FOOTER //
// ./src/components/molecules/CookieBar/component.js